// Google Places Autocomplete region filter shared by license state, street
// address, and zip lookup so those three requests do not drift.
//
// CA is needed for Canadian licenses and addresses. MX is included so Places
// can return Mexican states (license administrative_area_level_1). Recruiter
// address Save still validates against US+CA abbreviations only — Mexican
// states are not in SelectState.
export const PLACES_INCLUDED_REGION_CODES = ['US', 'CA', 'MX'] as const
